import sanitizeHtml from 'sanitize-html'

const defaultOptions = {
    allowedTags: ['b', 'i', 'em', 'strong', 'a', 'ul', 'li', 'span'],
    allowedAttributes: {
        a: ['href'],
    },
}

interface ISanitizeHTMLProps {
    html: string
    className?: string
}

function SanitizeHTML(props: ISanitizeHTMLProps) {
    const { html, className } = props

    return (
        <div
            className={className}
            dangerouslySetInnerHTML={{
                __html: sanitizeHtml(html, defaultOptions),
            }}
        />
    )
}

export default SanitizeHTML
